import './exportable_chart.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.SentimentHistogramView extends Monitoring.Reports.Campaign.ExportableChart
  include @, Monitoring.Reports.Campaign.Utils

  className: 'sentiment-histogram'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('processing')


    params = @paramsForChildsOfPosts
      dimension: 'sentiment'
      exclude_page_owner_generated: true

    $.post('/monitoring/api/charts/histogram', params, @_renderChart)

    return this

  _renderChart: (data) =>
    @series = {}
    for serie in data.series
      points = for point in serie.data
        {x: point[0], y: point[1]}
      @series[serie.code] = points

    @$el
      .removeClass('processing')
      .highcharts({
        chart: 
          type: 'areaspline'
          backgroundColor: "#FFFFFF"
          height: 400
          style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}
        title: null
        exporting:
          chartOptions:
            title: null 
        xAxis:
          type: 'datetime'
        yAxis:
          title:
            enabled: false
        plotOptions:
          series:
            marker:
              enabled: false
        series: [
          {
            name: I18n.t('monitoring.dashboard.charts.negative')
            color: @options.colors.negative
            stacking: 'normal'
            data: @series.negative
          }, 
          {
            name: 'Neutral'
            color: @options.colors.neutral
            stacking: 'normal'
            data: @series.neutral
          }, 
          {
            name: I18n.t('monitoring.dashboard.charts.positive')
            color: @options.colors.positive
            stacking: 'normal'
            data: @series.positive
          }
        ] 
      })

    @trigger('rendered')